import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    appLayout: {
      boxSizing: 'border-box',
      padding: [Spacings.s0, 120],

      [mediaQuery(1365)]: {
        position: 'initial',
        maxWidth: 934,
      },

      [mediaQuery(1023)]: {
        padding: [Spacings.s0, Spacings.s32],
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s0, Spacings.s24],
      },
    },
  }),
  {
    name: 'centered',
  },
);

export default useStyles;
